import { FC } from 'react'
import { ReactComponent as WarningIcon } from 'src/assets/svg/warning.svg'
import styles from './warningBanner.module.scss'

interface WarningBannerProps {
  text: string
  variant?: 'danger' | 'neutral'
}

export const WarningBanner: FC<WarningBannerProps> = ({
  text,
  variant = 'danger',
}) => {
  return (
    <div
      className={`${styles.warningContainer} ${
        variant === 'neutral' ? styles.neutral : styles.danger
      }`}
    >
      <WarningIcon className={styles.warningIcon} />
      <p className={styles.warningText}>{text}</p>
    </div>
  )
}
